import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Modal, Input, H3, Text, Worksheet, Button } from '@bigcommerce/big-design';

import { updateShipments } from '../../redux/actions/purchaseOrders';

const DeleteShipmentModal = ({ payload, showDeleteShipmentModal, setShowDeleteShipmentModal, shipment, sendUpdateShipments, bigcommerceSettings, shipments, setShipments, purchaseOrderId }) => {
  const update = () => {
    let newShipments = [...shipments];
    let toUpdateIndex = newShipments.findIndex((ship) => ship.id === shipment.id);

    delete newShipments[toUpdateIndex];

    sendUpdateShipments(payload, purchaseOrderId, newShipments.filter(n => n));
    setShipments(newShipments.filter(n => n));
    setShowDeleteShipmentModal(false);
  }

  return (
    <>
      <Modal
        actions={[
          {
            text: 'Cancel',
            variant: 'subtle',
            onClick: () => setShowDeleteShipmentModal(false),
          },
          { text: 'Delete Shipment', onClick: () => update() },
        ]}
        closeOnClickOutside={true}
        closeOnEscKey={true}
        header="Delete Shipment"
        isOpen={showDeleteShipmentModal}
        onClose={() => setShowDeleteShipmentModal(false)}
      >
        <H3>Delete this shipment?</H3>
        <Text>Shipping company: { shipment.company_name }</Text>
        <Text>Tracking #: { shipment.tracking }</Text>
        <Text>Taxes/Duties: { shipment.taxes }</Text>
        <Text>Other: { shipment.other }</Text>
      </Modal>
    </>
  )

}

const mapStateToProps = state => ({
  bigcommerceSettings: state.stores.settings,
});

const mapDispatchToProps = (dispatch) => ({
  sendUpdateShipments: (payload, purchaseOrderId, shipments) => dispatch(updateShipments(payload, purchaseOrderId, shipments)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteShipmentModal);
